import mobileDownloadNavigation from './mobile_download_navigation.vue'
import { createCmpEngine } from '@/utils'

export const openMobileDownloadNavigation = createCmpEngine(mobileDownloadNavigation)
